import { render, staticRenderFns } from "./courseSlider.vue?vue&type=template&id=57522610&"
import script from "./courseSlider.vue?vue&type=script&lang=js&"
export * from "./courseSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\src\\KoRus.Nord\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57522610')) {
      api.createRecord('57522610', component.options)
    } else {
      api.reload('57522610', component.options)
    }
    module.hot.accept("./courseSlider.vue?vue&type=template&id=57522610&", function () {
      api.rerender('57522610', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Assets/Scripts/Components/Organisms/slider/courseSlider.vue"
export default component.exports